// extracted by mini-css-extract-plugin
export default {"item":"Item_item__JsfQc","title":"Item_title__V9WqJ"};